export const environment = {
  dev: true,
  uat: false,
  prod: true,
  apiUrl :'https://prod-mscvp-backend.rehlko-edi.com/ediscv',          // backend mscvp
    webFormsUrl : 'https://webforms-prod.rehlko-edi.com',           // frontend webforms
    apiEndpoint :  'https://prod-webforms-backend.rehlko-edi.com/webforms',      // webforms backend

  // apiUrl: 'http://172.17.12.117:8151/ediscv',      // backend mscvp
  // webFormsUrl: 'http://172.17.12.61:4200',       // frontend webforms
  // apiUrl: 'https://mscvp-backend.rehlko-edi.com/ediscv',      // backend mscvp
  // webFormsUrl: 'https://webforms-dev.rehlko-edi.com',
  // apiEndpoint: 'https://webforms-backend.rehlko-edi.com/webforms',      // webforms backend

    // apiUrl :'https://prod-mscvp-backend.rehlko-edi.com/ediscv',          // backend mscvp
    // webFormsUrl : 'https://webforms-prod.rehlko-edi.com',           // frontend webforms
    // apiEndpoint :  'https://prod-webforms-backend.rehlko-edi.com/webforms',      // webforms backend
  envName: "",
  amcPartnerIds: ['311135B2BI', 'AMC', '311135B2BT', '3111350000'],


  url: "https://login.microsoftonline.com/5708517f-12b6-42d8-a59c-6c3b90001d59/v2.0/.well-known/openid-configuration",
  logout: "https://login.microsoftonline.com/5708517f-12b6-42d8-a59c-6c3b90001d59/oauth2/v2.0/logout",
  // redirectUri: "https://cors-mscvpfe.rehlko-edi.com/mscvp/sign-in",
  redirectUri: 'http://localhost:4200/mscvp/profile',
  loginUrl: 'http://localhost:8151/ediscv/oauth2/authorization/azure',
  responseType: 'code',
  scope: 'openid profile email offline_access',
  issuer: 'https://login.microsoftonline.com/5708517f-12b6-42d8-a59c-6c3b90001d59/v2.0',
  strictDiscoveryDocumentValidation: false,
  tokenEndpoint: 'https://login.microsoftonline.com/5708517f-12b6-42d8-a59c-6c3b90001d59/oauth2/v2.0/token',
  skipIssuerCheck: true,
  clearHashAfterLogin: true,
  clientId: 'da81b7a8-22a9-4ed1-828e-5c9fec06c387',
  oidc: true,
  usePkce: true,
  clientSecret: '5708517f-12b6-42d8-a59c-6c3b90001d59',
  disableAtHashCheck: true,
};
